import React from 'react';

import backend from 'utils/backend';
import userUtil from 'utils/miscellaneous/user/user_util';

const useActiveAdmins = () => {
  const [admins, setAdmins] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    let mounted = true;

    const loadAdmins = async () => {
      try {
        const filter = [
          {key: 'status', value: ['ACTIVE']},
          {key: 'role', value: 'ADMIN'},
        ];
        const result = await backend.user.queryUser(filter);

        if (mounted) {
          setAdmins((result.list || []).sort((a, b) => {
            return userUtil.getFullName(a.firstName, a.lastName).localeCompare(userUtil.getFullName(b.firstName, b.lastName));
          }));
        }
      } catch (error) {
        console.error('Failed to load admin users', error);
      } finally {
        if (mounted) {
          setIsLoading(false);
        }
      }
    };

    loadAdmins();

    return () => {
      mounted = false;
    };
  }, []);

  return {admins, isLoading};
};

export default useActiveAdmins;
